<template>
  <div>
    <template v-if="!isShowEdit">
      <div class="custom-search d-flex justify-content-end mb-2">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1 text-nowrap">Tìm kiếm</label>
            <b-form-input
              v-model="searchTxt"
              placeholder="Tìm kiếm"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </div>

      <vue-good-table
        mode="remote"
        :columns="fields"
        :rows="tableItems"
        :total-rows="pagination.total"
        :is-loading="tableLoading"
        :pagination-options="{
          enabled: true,
        }"
        :line-numbers="true"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'isDisabled'">
            <b-badge
              :variant="getStatusVariant(!props.row.isDisabled)"
              title="Nhấn để đổi trạng thái"
              class="cursor-pointer"
            >
              {{ getStatusText(!props.row.isDisabled) }}
            </b-badge>
          </span>

          <!-- time  -->
          <span v-if="props.column.field === 'time'">
            {{ formatPrice(props.row.time) }} giây
          </span>
          <!-- end time -->

          <!-- watting  -->
          <span v-else-if="props.column.field === 'wattingTime'">
            {{ formatPrice(props.row.wattingTime) }} giây
          </span>
          <!-- watting -->

          <!-- actions  -->
          <span v-else-if="props.column.field === 'action'">
            <action-update-product
              :data="props.row"
              @edit-clicked="(e) => onClickEditProduct(props.row)"
            />
          </span>
          <!-- end actions -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap">Showing 1 to</span>
              <b-form-select
                v-model="pagination.perPage"
                :options="['10', '20', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap">of {{ props.total }} entries</span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pagination.perPage"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>

        <div slot="emptystate" class="text-center">
          Không có dữ liệu để hiển thị.
        </div>

        <div slot="loadingContent">
          <b-spinner variant="primary" />
        </div>
      </vue-good-table>
    </template>

    <UpdatedProduct
      v-else
      :data="productSelected"
      @updated="onUpdated"
      @close="isShowEdit = false"
    />
  </div>
</template>

<script>
import {
  BPagination,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BFormSelect,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";

import debounce from "lodash.debounce";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { formatDateTime, formatPrice } from "@/helpers/format";
import LoadingButton from "@/@core/components/loading-button/LoadingButton.vue";
import API from "@/api";
import vSelect from "vue-select";
import ActionUpdateProduct from "@/components/Product/ActionUpdateProduct.vue";
import UpdatedProduct from "@/components/Product/UpdateProduct.vue";

export default {
  components: {
    BPagination,
    BFormInput,
    BFormGroup,
    BButton,
    BSpinner,
    BFormSelect,
    VueGoodTable,
    BBadge,
    LoadingButton,
    vSelect,
    ActionUpdateProduct,
    UpdatedProduct,
  },

  data() {
    return {
      fields: [
        {
          field: "name",
          label: "Tên trò chơi",
        },
        {
          field: "time",
          label: "Thời gian",
        },

        {
          field: "wattingTime",
          label: "Thời gian chờ",
        },

        {
          field: "action",
          label: "Hành động",
        },
      ],

      tableItems: [],
      tableLoading: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0,
      },
      searchTxt: "",
      isShowEdit: false,
      productSelected: null,
    };
  },

  computed: {},

  directives: {
    "b-tooltip": VBTooltip,
  },

  methods: {
    formatDateTime,
    formatPrice,
    onSearch: debounce(function () {
      this.fetchTableData(1, this.pagination.perPage);
    }, 500),

    fetchTableData(page, size) {
      this.tableLoading = true;
      const params = { page, size };
      if (this.searchTxt) {
        params.username = this.searchTxt;
      }
      this.$http
        .get(API.PRODUCT_LIST, { params })
        .then((res) => {
          this.tableItems = res.data;
          this.$set(this.pagination, "total", res.total);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    onPerPageChange({ currentPerPage }) {
      this.fetchTableData(1, currentPerPage);
    },
    onPageChange({ currentPage, currentPerPage }) {
      this.fetchTableData(currentPage, currentPerPage);
    },

    getStatusText(value) {
      if (!value) return "Đang khóa";
      return "Đang hoạt động";
    },

    getStatusVariant(value) {
      if (!value) return "danger";
      return "success";
    },

    onClickEditProduct(value) {
      this.isShowEdit = true;
      this.productSelected = value;
    },

    onUpdated() {
      this.fetchTableData();
    },
  },

  watch: {
    searchTxt(value) {
      this.onSearch();
    },
  },
  created() {
    this.fetchTableData(1, this.pagination.perPage);
  },
  mounted() {},
};
</script>
